
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectStatusFilter } from "../../redux/selector";
import { adminManagementSlice } from "../../redux/slice";
import { statusFilter } from "../../types";
import { useStyles } from "./styles";
import { AddButton } from "../../../../components/Button/AddButton"
import { FilterSelect } from "../../../../components/FilterSelect"

const STATUS_OPTIONS: statusFilter[] = [
  "ALL",
  "ACTIVE",
  "NOT_ACTIVE",
];




export const ActionBar = () => {

    const { t } = useTranslation();
    const styles = useStyles();
    const dispatch = useDispatch();
    const statusFilter = useSelector(selectStatusFilter);

    const handleStatusChange = (value: statusFilter) => {
          dispatch(adminManagementSlice.actions.setStatusFilter(value))
      } 

    
    const getStatusLabel = (value: statusFilter) =>
        t(
          value === "ALL"
            ? "ADMIN_MANAGEMENT.STATUS_ALL"
            : `ADMIN_MANAGEMENT.STATUS_VALUES.${value}`
        ); 

    
    
  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton label={t("USER_MANAGEMENT.ADD")}/>
      </div>
      <FilterSelect 
          label={t("ADMIN_MANAGEMENT.TABLE.STATUS")}
          value={statusFilter}
          options={STATUS_OPTIONS}
          getOptionLabel={(value) => getStatusLabel(value)}
          onChange={handleStatusChange}/>
    </div>
  );
};
    
